// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__2y_99","title":"card_title__2GSUd","inActive":"card_inActive__co21T"};